<template>
  <div class="div-dashMobile">
    <internnavbarmobile />
    <div class="card-item">
      <div class="card-i-align">
        <router-link :to="{ name: 'redacao', params: { cargo_id } }" style="color:white;">
          <img class="card-i-align-img" src="../../assets/images/icon-color/file-w.svg" />
          <span class="card-i-align-text">Minhas Redações</span>
        </router-link>
      </div>
    </div>
    <div class="card-item card-item-p">
      <div class="card-i-align">
        <img class="card-i-align-img" src="../../assets/images/icon-color/propostas-w.svg" />
        <span class="card-i-align-text">Propostas</span>
      </div>
    </div>
    <div class="card-item card-item-s">
      <div class="card-i-align">
        <img class="card-i-align-img" src="../../assets/images/icon-color/simulados-w.svg" />
        <span class="card-i-align-text">Simulados</span>
      </div>
    </div>
    <br />
    <span class="span-div-carousel">Biblioteca</span>
    <div class="div-carousel">
      <carousel>
        <slide class="carousel-slides">
          <div class="carousel-item">
            <div>
              <img src="../../assets/images/icon-color/videoaulas.svg" />
            </div>
            <span>Videoaulas</span>
          </div>
        </slide>
        <slide class="carousel-slides">
          <div class="carousel-item">
            <div>
              <img src="../../assets/images/icon-color/tutoriais.svg" />
            </div>
            <span>Tutoriais</span>
          </div>
        </slide>
        <slide class="carousel-slides">
          <div class="carousel-item">
            <div>
              <img src="../../assets/images/icon-color/materiais.svg" />
            </div>
            <span>Materiais</span>
          </div>
        </slide>
        <slide class="carousel-slides">
          <div class="carousel-item">
            <div>
              <img src="../../assets/images/icon-color/folhaderedacao.svg" />
            </div>
            <span>Folhas de Redação</span>
          </div>
        </slide>
      </carousel>
    </div>
    <bottomtabsmobile />
  </div>
</template>
<script>
import internnavbarmobile from "@/components/Navbars/InternNavMobile";
import bottomtabsmobile from "@/components/Tabs/BottomNavigationMobile";
import store from "@/store";

export default {
  data() {
    return {
      cargo_id: store.getters.cargo_id
    };
  },
  components: {
    internnavbarmobile: internnavbarmobile,
    bottomtabsmobile: bottomtabsmobile
  }
};
</script>